import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  FetchModelBlocks,
  getDashboard,
  getDashboardBlockStatus,
  resetDashboardSliceV2,
} from 'redux/DashboardSliceV2';
import { getBlocks } from 'redux/ModelsSlice';
import { AppDispatch } from 'utils/GlobalHelpers';
import { STATUS } from 'projectConstants';

/** Dashboard canvas data only — model list/route bootstrap lives in useModelDashboardBootstrap. */
const useDashboardData = ({ enable = false }: { enable?: boolean }) => {
  const model = useSelector(getBlocks);
  const dashboard = useSelector(getDashboard);
  const dashboardBlockStatus = useSelector(getDashboardBlockStatus);
  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    return () => {
      if (enable && dashboard?.id) dispatch(resetDashboardSliceV2());
    };
  }, [dispatch, enable, dashboard?.id]);

  useEffect(() => {
    if (model.id && enable && dashboardBlockStatus === STATUS.IDLE) {
      dispatch(FetchModelBlocks({ modelId: Number(model.id) }));
    }
  }, [model.id, enable, dashboardBlockStatus, dispatch]);
};

export default useDashboardData;
